import { Image, Link } from "@customTypes/index";
import { Col, Row } from "antd";

interface YoutubeCardProps {
  className?: string;
  title?: string;
  date?: string;
  description?: string;
  link: Link;
  image: Image;
}

const defaultProps: YoutubeCardProps = {
  className: "",
  title: "No title found",
  date: "March 24, 2021",
  description: "quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
  image: {
    src: "https://covrprice.com/wp-content/uploads/2020/02/STL145248.jpg",
    alt: "no image",
  },
};

const YoutubeCard = ({ className, title, date, description, link, image }: YoutubeCardProps) => {
  return (
    <a target={link.target} href={link.url}>
      <Row className={`covr-cta-youtube-card ${className}`}>
        <Col span={24} className="top">
          <img alt={image.alt} src={image.src} className="responsive-img" loading="lazy" />
        </Col>
        <Col span={24} className="bottom">
          <h3 className="title ellipsis">{title}</h3>
          <p className="description">{description}</p>
        </Col>
      </Row>
    </a>
  );
};

YoutubeCard.defaultProps = defaultProps;

export default YoutubeCard;
